/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenuBuilderComponentDto
 */
export interface MenuBuilderComponentDto {
    /**
     * 
     * @type {string}
     * @memberof MenuBuilderComponentDto
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof MenuBuilderComponentDto
     */
    productName: string;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    sequence: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    defaultPrice: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    defaultTakeawayPrice: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    priceOverride?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    takeawayPriceOverride?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    effectivePrice: number;
    /**
     * 
     * @type {number}
     * @memberof MenuBuilderComponentDto
     */
    effectiveTakeawayPrice: number;
    /**
     * 
     * @type {string}
     * @memberof MenuBuilderComponentDto
     */
    productSizeId: string;
    /**
     * 
     * @type {string}
     * @memberof MenuBuilderComponentDto
     */
    label?: string;
}

/**
 * Check if a given object implements the MenuBuilderComponentDto interface.
 */
export function instanceOfMenuBuilderComponentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "productName" in value;
    isInstance = isInstance && "sequence" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "defaultPrice" in value;
    isInstance = isInstance && "defaultTakeawayPrice" in value;
    isInstance = isInstance && "effectivePrice" in value;
    isInstance = isInstance && "effectiveTakeawayPrice" in value;
    isInstance = isInstance && "productSizeId" in value;

    return isInstance;
}

export function MenuBuilderComponentDtoFromJSON(json: any): MenuBuilderComponentDto {
    return MenuBuilderComponentDtoFromJSONTyped(json, false);
}

export function MenuBuilderComponentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuBuilderComponentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'productName': json['productName'],
        'sequence': json['sequence'],
        'quantity': json['quantity'],
        'defaultPrice': json['defaultPrice'],
        'defaultTakeawayPrice': json['defaultTakeawayPrice'],
        'priceOverride': !exists(json, 'priceOverride') ? undefined : json['priceOverride'],
        'takeawayPriceOverride': !exists(json, 'takeawayPriceOverride') ? undefined : json['takeawayPriceOverride'],
        'effectivePrice': json['effectivePrice'],
        'effectiveTakeawayPrice': json['effectiveTakeawayPrice'],
        'productSizeId': json['productSizeId'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function MenuBuilderComponentDtoToJSON(value?: MenuBuilderComponentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productId': value.productId,
        'productName': value.productName,
        'sequence': value.sequence,
        'quantity': value.quantity,
        'defaultPrice': value.defaultPrice,
        'defaultTakeawayPrice': value.defaultTakeawayPrice,
        'priceOverride': value.priceOverride,
        'takeawayPriceOverride': value.takeawayPriceOverride,
        'effectivePrice': value.effectivePrice,
        'effectiveTakeawayPrice': value.effectiveTakeawayPrice,
        'productSizeId': value.productSizeId,
        'label': value.label,
    };
}

